import Base from './base'
import Vue from 'vue'
import { Message } from 'element-ui'

class LinkAge extends Base {
  constructor () {
    super('LinkAge')
  }

  /**
   * 获取智联配置数据
   * @param {String} zoneId 区域id
   */
  async getLinkAge (zoneId) {
    const result = await Vue.axios.get(`${Vue._config.dmi}/linkage/${zoneId}`)
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('智联配置数据获取失败！')
      result.data.data = []
    }
    return result.data.data
  }

  /**
   * 保存智联配置数据
   * @param {Object} params
   * @param {Number} zoneId
   * @param {Number} deviceId
   * @param {String} rule
   */
  async saveLinkAge (params) {
    const result = await Vue.axios.put(`${Vue._config.dmi}/linkage/${params.zoneId}`, params)
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('保存失败！')
      result.data.data = []
    }
    return result.data.data
  }

  /**
   * 更新智联配置数据
   * @param {Object} params
   * @param {Number} id
   * @param {Number} zoneId
   * @param {Number} deviceId
   * @param {String} rule
   */
  async updataLinkAge (params) {
    const result = await Vue.axios.post(`${Vue._config.dmi}/linkage/${params.id}`, params)
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('保存失败！')
      result.data.data = []
    }
    return result.data.data
  }
}

export default new LinkAge()
